const AdminDashboard = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return <h1 className="text-xl font-[500] font-[Poppins]">Welcome, {user?.email}</h1>;
};

export default AdminDashboard;
